import _environmentUserAgent from "../internals/environment-user-agent";
var exports = {};
var userAgent = _environmentUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);
export default exports;